export const mintArray = [
	{
		name: 'Philadelphia',
		value: 'P'
	},
	{
		name: 'Carson City',
		value: 'CC'
	},
	{
		name: 'Charlotee',
		value: 'C'
	},
	{
		name: 'Denver',
		value: 'D'
	},
	{
		name: 'New Orleans',
		value: 'O'
	},
	{
		name: 'San Francisco',
		value: 'S'
	},
	{
		name: 'West Point',
		value: 'W'
	},
	{
		name: 'No Mint Mark',
		value: 'N'
	}];